import { HeaderIconTooltip } from '@/components/content/Header/parts/HeaderIconTooltip';
import { HeaderMiniCartDropMenu } from '@/components/content/Header/parts/MiniCartDropMenu';
import { headerItemCartSX } from '@/components/content/Header/styles/itemStack';
import {
	frameCountCartSX,
	iconCountCartSX,
	numberCountCartSX,
} from '@/components/content/Header/styles/miniCart/container';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { Stack, Typography } from '@mui/material';
import { FC, MouseEventHandler } from 'react';
import { useLockBodyScroll } from '@/utils/useLockBodyScroll';
import { useHeaderTopOffset } from '@/components/content/Header/hooks/useHeaderTopOffset';

type Props = {
	open: boolean;
	count: number;
	fromLocal: boolean;
	handleToolTip: (action: string) => () => void;
	onMouseEnter: MouseEventHandler<HTMLDivElement>;
	onOpenFreeShippingActivatedPopup: (resumeCheckout: () => void) => Promise<boolean>;
};

export const HeaderMiniCartDesktop: FC<Props> = ({
	open,
	count,
	fromLocal,
	handleToolTip,
	onMouseEnter,
	onOpenFreeShippingActivatedPopup,
}) => {
	useLockBodyScroll(open);
	useHeaderTopOffset(open);

	return (
		<HeaderIconTooltip
			open={open}
			dropElement={
				open ? (
					<HeaderMiniCartDropMenu
						fromLocal={fromLocal}
						onClose={handleToolTip('close')}
						onOpenFreeShippingActivatedPopup={onOpenFreeShippingActivatedPopup}
					/>
				) : (
					<>{null}</>
				)
			}
			iconElement={
				<Stack
					id="MiniShoppingCart"
					alignItems="center"
					onClick={onMouseEnter}
					sx={headerItemCartSX(count > 0)}
				>
					<Stack sx={frameCountCartSX}>
						{count > 0 ? (
							<Typography sx={numberCountCartSX({ isMobile: false })}>{count}</Typography>
						) : null}
						<ShoppingCartIcon sx={iconCountCartSX({ isMobile: false })} />
					</Stack>
				</Stack>
			}
			onClose={handleToolTip('close')}
		/>
	);
};
